import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/main.scss';

const Snackbar = ({show, message, buttonAction, buttonLabel, alignStart}) => {
  const hasButton = buttonLabel.length > 0;
  return (
    <div
      aria-live="assertive" aria-atomic="true" aria-hidden={!show}
      className={`${'mdc-snackbar'}
      ${hasButton ? '' : 'mdc-snackbar__no_action'}
      ${alignStart ? 'mdc-snackbar--align-start' : ''}
      ${show ? 'mdc-snackbar--active' : ''}`}>
      <div className={`${'mdc-snackbar__text'}`}>{message}</div>
      {hasButton &&
        <div className={`${'mdc-snackbar__action-wrapper'}`}>
          <button
            type='button'
            onClick={buttonAction}
            className={`${'mdc-snackbar__action-button'}`}
            {...(buttonLabel.length === 0 && {'aria-hidden': true})}
          >
            {buttonLabel}
          </button>
        </div>
      }
    </div>
  );
};

Snackbar.propTypes = {
  alignStart: PropTypes.bool,
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  buttonAction: PropTypes.func
};

Snackbar.defaultProps = {
  alignStart: false,
  buttonLabel: '',
  buttonAction: () => {}
};

export default Snackbar;
